(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/store/redux.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/store/redux.js');

'use strict';

const {
  reducer: depositReducer,
  initialState: despositInitialState
} = svs.accountservicesReact.deposit.store.deposit;
const {
  reducer: swishReducer,
  initialState: swishInitialState
} = svs.accountservicesReact.deposit.store.swish;
const reducerObject = {
  deposit: depositReducer,
  swish: swishReducer
};

svs.accountservicesReact.deposit.store.createStore = function () {
  let preloaded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return RTK.configureStore({
    reducer: reducerObject,
    preloadedState: preloaded
  });
};

const store = svs.accountservicesReact.deposit.store.createStore({
  deposit: despositInitialState,
  swish: swishInitialState
});
const DepositReduxProvider = _ref => {
  let {
    children
  } = _ref;
  return React.createElement(ReactRedux.Provider, {
    store: store
  }, children);
};
svs.accountservicesReact.deposit.store.DepositReduxProvider = DepositReduxProvider;

 })(window);